import { useController } from 'react-hook-form';
import { TimeIn24HourClock, TypeaheadTimePicker, TypeaheadTimePickerProps } from 'ui/datePicker';
import { FieldProps } from './types';

type TypeaheadTimePickerFieldProps = FieldProps &
  Exclude<TypeaheadTimePickerProps, 'time' | 'onSelect' | 'isError'>;

export const TypeaheadTimePickerField = ({
  name,
  defaultValue,
  ...props
}: TypeaheadTimePickerFieldProps) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({
    name,
    defaultValue,
  });

  return (
    <TypeaheadTimePicker
      isError={!!error}
      {...props}
      time={value}
      onSelect={([time]) => onChange(time as TimeIn24HourClock)}
    />
  );
};
